import { render, staticRenderFns } from "./SelflaneIcon.vue?vue&type=template&id=15234b40&scoped=true"
var script = {}
import style0 from "./SelflaneIcon.vue?vue&type=style&index=0&id=15234b40&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15234b40",
  null
  
)

export default component.exports